import { FC } from 'react'

interface PinnedIconProps {
  size?: number
  color?: string
  className?: string
  opacity?: number
}

export const PinnedIcon: FC<PinnedIconProps> = ({
  size = 32,
  color = 'white',
  className = '',
  opacity = 1,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
    >
      <g>
        <path
          d="M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2ZM11.5 7.75C9.98122 7.75 8.75 8.98122 8.75 10.5V21.5C8.75 23.0188 9.98122 24.25 11.5 24.25H16L16.0771 24.2461C16.4551 24.2075 16.75 23.8882 16.75 23.5C16.75 23.1118 16.4551 22.7925 16.0771 22.7539L16 22.75H11.5C10.8096 22.75 10.25 22.1904 10.25 21.5V10.5C10.25 9.80964 10.8096 9.25 11.5 9.25H20.5C21.1904 9.25 21.75 9.80964 21.75 10.5V12.7188C21.75 13.133 22.0858 13.4688 22.5 13.4688C22.9142 13.4687 23.25 13.133 23.25 12.7188V10.5C23.25 8.98122 22.0188 7.75 20.5 7.75H11.5ZM23.6602 15.4668C23.2138 15.2092 22.6434 15.3623 22.3857 15.8086L18.6914 22.2061C18.6363 22.3016 18.6144 22.4131 18.6289 22.5225L18.7568 23.4844C18.7828 23.6796 18.9869 23.7968 19.1689 23.7217L20.0654 23.3516C20.1673 23.3095 20.2525 23.2351 20.3076 23.1396L24.002 16.7412C24.2595 16.2949 24.1065 15.7245 23.6602 15.4668ZM12.5 17.25C12.0858 17.25 11.75 17.5858 11.75 18C11.75 18.4142 12.0858 18.75 12.5 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18C18.75 17.5858 18.4142 17.25 18 17.25H12.5ZM12.5 12.75C12.0858 12.75 11.75 13.0858 11.75 13.5C11.75 13.9142 12.0858 14.25 12.5 14.25H19.5C19.9142 14.25 20.25 13.9142 20.25 13.5C20.25 13.0858 19.9142 12.75 19.5 12.75H12.5Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
